import { render, staticRenderFns } from "./GoodsListTr.vue?vue&type=template&id=4dc3a200&"
import script from "./GoodsListTr.vue?vue&type=script&lang=ts&"
export * from "./GoodsListTr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports